<div class="w-full flex flex-row justify-between h-20 mt-2">
    <mat-card
        appearance="outlined"
        class="h-full"
        [class]="showAddButton() ? 'w-2/3' : 'w-full'">
        <div class="p-2 flex flex-row items-center justify-between h-full">
            <div
                class="flex flex-col justify-between h-full"
                [class]="showAddButton() ? 'w-10/12' : 'w-full'">
                <p class="text-subtitle-1 truncate">{{ documentName }}</p>
                <div class="flex flex-row w-full justify-between items-end">
                    <p class="!m-0 text-caption">{{ document().type }}</p>
                    <p class="!m-0 text-on-surface">{{ document().size | byteFormat }}</p>
                </div>
            </div>
            <button
                class="w-1/6 ml-auto border-none bg-transparent text-on-surface cursor-pointer"
                [matMenuTriggerFor]="menu"
                (menuClosed)="toggleDropdownMenu(false)"
                (menuOpened)="toggleDropdownMenu(true)">
                <fa-icon [icon]="['fas', 'ellipsis']" />
            </button>

            <mat-menu #menu="matMenu">
                <button
                    mat-menu-item
                    type="button"
                    [disabled]="!documentService.canAccessDocument()"
                    [matTooltip]="(documentService.canAccessDocument() ? '' : 'insufficientPermissions') | transloco"
                    (click)="documentService.downloadDocument(document())">
                    {{ 'download' | transloco }}
                </button>

                <button
                    mat-menu-item
                    type="button"
                    [disabled]="!documentService.canManageDocuments()"
                    [matTooltip]="(documentService.canManageDocuments() ? '' : 'insufficientPermissions') | transloco"
                    (click)="documentService.deleteDocument(document())">
                    <span class="text-error">{{ 'delete' | transloco }}</span>
                </button>
            </mat-menu>
        </div>
    </mat-card>
    @if (showAddButton()) {
        <app-button
            iconSize="sm"
            [disabled]="!documentService.canManageDocuments()"
            [icon]="['fas', 'plus']"
            [label]="'add' | transloco"
            [matTooltip]="(documentService.canManageDocuments() ? '' : 'insufficientPermissions') | transloco"
            [type]="ButtonType.PRIMARY"
            (onClick)="documentService.add(dataEntity())" />
    }
</div>
